import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthServiceZ } from './auth-service.service';
import { SharedService } from './../shared/shared.service';

@Injectable({
  providedIn: 'root',
})
export class IntiGoAuthServices implements CanActivate {
  constructor(
    public auth: AuthServiceZ,
    public router: Router,
    public authService: AuthServiceZ,
    public sharedService: SharedService
  ) {}
  DefaultNonAuthorisedUrl = '/auth/login/admin';

  resolveRedirectUrl(userServices) {
    // if (userServices.includes('100') && userServices.includes('101')) {
    //   return '/finance/dashboard/list'
    // }

    return '/';
    return '/auth/login/admin';
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.auth.isAuthenticated()) {
        this.router.navigate(['/auth/login/admin']);
        resolve(false);
      }
      const services = route.data.services as Array<string>;
      const userServices = this.auth.credentials.user.services;

      console.log('services:', services);

      if (services.every((ps) => userServices.includes(ps))) {
        resolve(true);
      } else {
        this.router.navigate([this.resolveRedirectUrl(userServices)]);
        resolve(false);
      }
    });
  }
}
